import i18next from "i18next";
import urls from "./urls";
import {detectScheme, formatMoney, makeId} from "./utils";


const PAYMENT_ICONS = {
    Visa: `<svg class="icon" viewBox="0 0 60 40" xmlns="http://www.w3.org/2000/svg">
           <path d="M6 34 L18 6 L30 34 L42 6 L54 34" stroke="currentColor" stroke-width="6" fill="none"
                 stroke-linejoin="round" stroke-linecap="round"/></svg>`,

    Mastercard: `<svg class="icon" viewBox="0 0 60 40" xmlns="http://www.w3.org/2000/svg">
                 <circle cx="23" cy="20" r="15" fill="currentColor" fill-opacity=".85"/>
                 <circle cx="37" cy="20" r="15" fill="currentColor" fill-opacity=".45"/></svg>`,

    Amex: `<svg class="icon" viewBox="0 0 60 40" xmlns="http://www.w3.org/2000/svg">
           <rect x="6" y="6" width="48" height="28" rx="5" ry="5" fill="none" stroke="currentColor" stroke-width="4"/>
           <path d="M18 30 L24 10 L30 30" stroke="currentColor" stroke-width="4" fill="none" stroke-linejoin="round"/></svg>`,

    Discover: `<svg class="icon" viewBox="0 0 60 40" xmlns="http://www.w3.org/2000/svg">
               <path d="M6 26 A14 14 0 1 0 54 26" fill="currentColor"/></svg>`,

    UnionPay: `<svg class="icon" viewBox="0 0 60 40" xmlns="http://www.w3.org/2000/svg">
               <path d="M10 30 L10 10 L22 10 L35 30 Z" fill="currentColor"/></svg>`,

    Diners: `<svg class="icon" viewBox="0 0 60 40" xmlns="http://www.w3.org/2000/svg">
             <circle cx="30" cy="20" r="15" fill="none" stroke="currentColor" stroke-width="4"/>
             <circle cx="30" cy="20" r="6" fill="currentColor"/></svg>`,

    JCB: `<svg class="icon" viewBox="0 0 60 40" xmlns="http://www.w3.org/2000/svg">
          <rect x="10" y="10" width="10" height="20" fill="currentColor"/>
          <rect x="25" y="10" width="10" height="20" fill="currentColor"/>
          <rect x="40" y="10" width="10" height="20" fill="currentColor"/></svg>`,

    Maestro: `<svg class="icon" viewBox="0 0 60 40" xmlns="http://www.w3.org/2000/svg">
              <circle cx="23" cy="20" r="13" fill="currentColor" fill-opacity=".85"/>
              <circle cx="37" cy="20" r="13" fill="currentColor" fill-opacity=".45"/>
              <rect  x="23" y="13" width="14" height="14" fill="currentColor"/></svg>`,
};

export function displayError(text = 'Error') {
    displayAlert(text, 'alert-danger')
}

export function displaySuccess(text = 'Success') {
    displayAlert(text, 'alert-success')
}

export function displayAlert(text, className) {
    const alertContainerHtml = '<div class="d-flex justify-content-center align-items-center vw-100 position-fixed alert-container custom-alert-container" style="z-index: 19999;"></div>'
    const alertHtml = `<div class="alert ${className} custom-alert alert-dismissible fade show" role="alert">
  <span class="display-alert-text">${text}</span>
  <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
</div>`

    let alertContainer = $(alertContainerHtml);
    alertContainer.append($(alertHtml));
    $('#content').prepend(alertContainer)


    setTimeout(function () {

        $(`.${className}`).alert('close');
        $('.alert-container').remove();

    }, 1700);
}


export function handleFetchError(error) {
    console.error('Error fetching data:', error);
    if (typeof error === 'object') {
        // Access the object directly and display or handle as needed.
        // E.g., displayError(error.message);
    } else {
        displayError(error.toString());
    }
}


export function bindToolTips(selector = '.answer-tooltip') {
    new bootstrap.Tooltip(document.body, {
        selector: selector,
        delay: {
            show: 500,
            hide: 100
        },
        template: customTemplate,
    });
}

export function initializeTooltip(element) {
    new bootstrap.Tooltip(element, {
        delay: {
            show: 500,
            hide: 100
        },
        template: customTemplate,
    });
}

export const customTemplate = `<div class="tooltip ogo-tooltip" role="tooltip">
  <div class="tooltip-arrow ogo-tooltip-arrow"></div>
  <div class="tooltip-inner ogo-tooltip-inner">
    <span id="tooltip-content"></span>
  </div>
</div>`


export function noAccountsHtml() {

    const noAccountsTitleTran = i18next.t('common:dom.noAccountsTitle') // Вы пока не добавили аккаунтов OLX.
    const noAccountsTextTran = i18next.t('common:dom.noAccountsText') // Добавть свой первый аккаунт прямо сейчас.
    const noAccountsButtonTran = i18next.t('common:dom.noAccountsButton') // Добавить новый
    return genAccountWarningModalHtml(noAccountsTitleTran, noAccountsTextTran, noAccountsButtonTran)
}


function genAccountWarningHtml(title, text, buttonText, url) {
    return `<div class="container-xl"><div class="mt-5 mb-5 text-center">
<div class="d-flex justify-content-center mb-3">
<h2 class="col12 col-sm-10 col-md-8">${title}</h2>
</div>
            
            <div class="d-flex mb-3 justify-content-center">
            <p class="col12 col-sm-8 col-md-6 ">${text}</p>
            </div>
            <a href="${url}" class="filled-button">${buttonText}</a>
        </div></div>`
}


function genAccountWarningModalHtml(title, text, buttonText) {
    return `<div class="container-xl"><div class="mt-5 mb-5 text-center">
<div class="d-flex justify-content-center mb-3">
<h2 class="col12 col-sm-10 col-md-8">${title}</h2>
</div>
            
            <div class="d-flex mb-3 justify-content-center">
            <p class="col12 col-sm-8 col-md-6 ">${text}</p>
            </div>
            <a href="#" class="filled-button" data-bs-toggle="modal" data-bs-target="#addAccountModal">${buttonText}</a>
        </div></div>`
}


export function expiredAccountsHtml() {

    const title = i18next.t('common:dom.expiredAccountsTitle') // У вас нет активных аккаунтов OLX.
    const text = i18next.t('common:dom.expiredAccountsText') // Но у вас есть один или несколько аккаунтов с истекшим сроком подключения. Для продолжения использования сервиса, пожалуйста, обновите подключение хотя бы одного из них или добавьте новый аккаунт.
    const buttonText = i18next.t('common:dom.expiredAccountsButton') // Обновить или добавить новый аккаунт
    return genAccountWarningHtml(title, text, buttonText, urls.accountsPage)
}

export function inactiveAccountsHtml() {
    const title = i18next.t('common:dom.inactiveAccountsTitle') // У вас нет активных аккаунтов OLX.
    const text = i18next.t('common:dom.inactiveAccountsText') // Но у вас есть один или несколько выключенных аккаунтов. Для продолжения использования сервиса, пожалуйста, включите хотя бы один из них или добавьте новый аккаунт.
    const buttonText = i18next.t('common:dom.inactiveAccountsButton') // Включить или добавить новый аккаунт
    return genAccountWarningHtml(title, text, buttonText, urls.accountsPage)
}

export function expiredAndInactiveAccountsHtml() {
    const title = i18next.t('common:dom.expiredAndInactiveAccountsTitle') // Вы пока не добавили аккаунтов OLX.
    const text = i18next.t('common:dom.expiredAndInactiveAccountsText') // У вас есть аккаунты OLX, которые в настоящее время отключены или имеют истекший срок подключения. Для восстановления активности и продолжения использования наших сервисов, пожалуйста, обновите подключение или включите хотя бы один из ваших аккаунтов.
    const buttonText = i18next.t('common:dom.expiredAndInactiveAccountsButton') // Обновить или включить аккаунты
    return genAccountWarningHtml(title, text, buttonText, urls.accountsPage)
}


export function hideModal(modalId) {
    const myModalEl = document.getElementById(modalId);
    const modal = bootstrap.Modal.getInstance(myModalEl);
    modal.hide();
}


export function makeAppHeaderAbsolute() {
    let appHeader = $('.app-header')
    appHeader.css('position', 'absolute')
    appHeader.addClass('app-header-absolute')
}


export function makeAppHeaderSticky() {
    let appHeader = $('.app-header')
    appHeader.addClass('app-header-sticky')
}


export function appendScrollButtons() {
    const body = $('body');
    body.append('<div id="scroll-up" class="scroll-btn"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" viewBox="0 0 24 24" style="width: 39px" xml:space="preserve"><g><path d="M16.2 10.2c-.2.2-.5.3-.7.3s-.5-.1-.7-.3L13 8.4V21c0 .5-.5 1-1 1s-1-.5-1-1V8.4l-1.8 1.8c-.4.4-1 .4-1.4 0s-.4-1 0-1.4l3.5-3.5c.4-.4 1-.4 1.4 0l3.5 3.5c.4.4.4 1 0 1.4zM20 4H4c-.6 0-1-.4-1-1s.4-1 1-1h16c.6 0 1 .4 1 1s-.4 1-1 1z" fill="currentColor" opacity="1" data-original="#000000"/></g></svg></div>');
    body.append('<div id="scroll-down" class="scroll-btn"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" viewBox="0 0 24 24" style="width: 39px" xml:space="preserve" class=""><g><path d="m16.2 15.2-3.5 3.5c-.2.2-.4.3-.7.3s-.5-.1-.7-.3l-3.5-3.5c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l1.8 1.8V3c0-.5.5-1 1-1s1 .5 1 1v12.6l1.8-1.8c.4-.4 1-.4 1.4 0s.4 1 0 1.4zM20 22H4c-.6 0-1-.4-1-1s.4-1 1-1h16c.6 0 1 .4 1 1s-.4 1-1 1z" fill="currentColor" opacity="1" data-original="#000000" class=""/></g></svg></div>');
    $('#scroll-up, #scroll-down').hide();
}


export function appendCollapseAllButton() {
    $('body').append('<div id="collapse-all" class="scroll-btn"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" viewBox="0 0 128 128" style="width: 39px" xml:space="preserve" ><g><path xmlns="http://www.w3.org/2000/svg" id="" d="m64 88c-1.023 0-2.047-.391-2.828-1.172l-40-40c-1.563-1.563-1.563-4.094 0-5.656s4.094-1.563 5.656 0l37.172 37.172 37.172-37.172c1.563-1.563 4.094-1.563 5.656 0s1.563 4.094 0 5.656l-40 40c-.781.781-1.805 1.172-2.828 1.172z" fill="currentColor" data-original="#000000" class=""></path></g></svg></div>');
    $('#collapse-all').hide();
}


export function hideCollapseButton() {
    $('#collapse-all').hide();
}


export function collapseAll() {
    $('.transform').each(function (element) {
        const targetId = $(this).attr('data-bs-target');
        const targetElement = $(targetId);
        if (targetElement.hasClass('show')) {
            $(this).click();  // Эмулируем клик по кнопке для закрытия
        }
    });
    $(this).hide()
}

export function generateModalHTML(modalTitle, modalBody, modalFooter, modalId, modalCSS, modalAttrs) {

    const modalTitleHTML = modalTitle ? `<strong>${modalTitle}</strong>` : "";
    const modalFooterHTML = modalFooter ? `<div class="modal-footer">${modalFooter}</div>` : "";

    const id = modalId ? modalId : "modal_" + makeId();


    return `<div class="modal" id="${id}" tabindex="-1" role="dialog" aria-labelledby="${id}"
     aria-hidden="true" ${modalAttrs}>
    <div class="modal-dialog modal-dialog-centered ${modalCSS}" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">${modalTitleHTML}</h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
               ${modalBody}
            </div>
             ${modalFooterHTML}
        </div>
    </div>
</div>`
}

export function displayManageSubscriptionModal(billingData) {

}


export function renderBillingHtml(data) {
    const {
        current_subscription: sub,
        balance,
        tokens_total_left,
        connections_total,
        has_saved_cards,
    } = data;

    // ───────── вспом. util-функции ────────────────────────────
    const fmtDate = iso =>
        new Date(iso).toLocaleDateString(undefined, {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });

    const badgeColorByPlan = plan => {
        switch (plan) {
            case "STARTER":
                return "bg-success";
            case "BASE":
                return "bg-primary";
            case "PRO":
                return "bg-info text-dark";
            default:
                return "bg-secondary";
        }
    };


    if (!sub || !sub.exists) {
        const noActiveSubscriptionTitle = i18next.t('common:dom.manageSubscriptionModalNoActiveSubscriptionTitle', 'You don\'t have an active subscription yet.')
        return `<div class="alert alert-info text-center">
        ${noActiveSubscriptionTitle}
      </div>`

    }


    const progressColor = pct =>
        pct >= 50 ? "bg-success" : pct >= 30 ? "bg-warning" : "bg-danger";

    const progressPercent = (left, total) => {
        if (!total) {
            return 0
        }

        const pct = Math.round((left / total) * 100)
        return Math.max(0, Math.min(100, pct))
    }

    const price = formatMoney(sub.total_price, balance.currency)
    const masked_pan = sub.masked_pan ? sub.masked_pan.slice(-4) : "";

    const currentPlanTitle = i18next.t('common:dom.manageSubscriptionModalCurrentPlanTitle', 'Current Plan')
    const monthlyPlanTitle = i18next.t('common:dom.manageSubscriptionModalMonthlyPlanTitle', 'Monthly plan')
    const yearlyPlanTitle = i18next.t('common:dom.manageSubscriptionModalYearlyPlanTitle', 'Yearly plan')

    const cancelSubscriptionLinkTitle = i18next.t('common:dom.manageSubscriptionModalCancelSubscriptionLinkTitle', 'Cancel subscription')
    const enableSubscriptionLinkTitle = i18next.t('common:dom.manageSubscriptionModalEnableSubscriptionLinkTitle', 'Enable subscription')

    const renewAtTitle = i18next.t('common:dom.manageSubscriptionModalRenewAtTitle', 'Renew at')
    const validToTitle = i18next.t('common:dom.manageSubscriptionModalValidToTitle', 'Valid to')

    const usageTitle = i18next.t('common:dom.manageSubscriptionModalUsageTitle', 'Usage')
    const usageRenewalPeriodText = i18next.t('common:dom.manageSubscriptionModalUsageRenewalPeriodText', 'Your usage is renewed every month')

    const connectionsTitle = i18next.t('common:dom.manageSubscriptionModalConnectionsTitle', 'Connections')
    const tokensTitle = i18next.t('common:dom.manageSubscriptionModalTokensTitle', 'Tokens')
    const accountsTitle = i18next.t('common:dom.manageSubscriptionModalAccountsTitle', 'Accounts')
    const ofTitle = i18next.t('common:dom.manageSubscriptionModalOfTitle', 'Of')


    let planPeriod = ""
    let dateTitle = renewAtTitle

    let linkHTML = ""

    if (sub && sub.auto_renew) {
        dateTitle = renewAtTitle
        linkHTML = `<a style="color: #133217; font-size: smaller;" href="#"
                                       class="cancel-subscription-link" data-bs-target="#cancelSubscriptionModal"
                                       data-bs-toggle="modal" data-bs-dismiss="modal">${cancelSubscriptionLinkTitle}</a>`

    } else if (sub && sub.exists) {
        dateTitle = validToTitle

    }

    if (sub && sub.duration === "30") {
        planPeriod = monthlyPlanTitle
    } else if (sub && sub.duration === "365") {
        planPeriod = yearlyPlanTitle
    }

    const duration = sub && sub.duration ? sub.duration : "";

    const everyTitle = i18next.t('common:dom.manageSubscriptionModalEveryTitle', {days: duration})

    const accountsLimit = Number(sub.account_limit) || 0
    const accountsCount = Number(sub.accounts_count) || 0
    const accountsFree = Math.max(accountsLimit - accountsCount, 0)


    return /* html */ `

    <!-- Текущая подписка -->
    ${
        sub && sub.exists
            ? /* html */ `
      <h6 class="fw-semibold mb-2">${currentPlanTitle}</h6>
      <div class="card p-3 mb-4">
        <div class="d-flex justify-content-between align-items-start">
          <div>
            <p class="text-muted small mb-0">${planPeriod}</p>
            <div class="d-flex align-items-center">
              <span class="big fw-bold">
                ${
                +sub.total_price > 0
                    ? `${price} ${everyTitle}`
                    : "Free"
            }
              </span>
              ${
                masked_pan && sub.auto_renew
                    ? /* html */ `
              <span class="ms-2 text-muted small d-flex align-items-center">
              <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                                         xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                         viewBox="0 0 122.88 78.22"
                                         style="enable-background:new 0 0 122.88 78.22; width: 14px; height: 14px; margin-right: 4px;"
                                         xml:space="preserve"><style type="text/css">.st0 {
                                        fill-rule: evenodd;
                                        clip-rule: evenodd;
                                    }</style><g><path class="st0" d="M86.63,45.01c3.23,0,6.1,1.56,7.89,3.96c1.79-2.41,4.66-3.96,7.89-3.96c5.43,0,9.83,4.4,9.83,9.83 c0,5.43-4.4,9.83-9.83,9.83c-3.23,0-6.1-1.56-7.89-3.96c-1.79,2.41-4.66,3.96-7.89,3.96c-5.43,0-9.83-4.4-9.83-9.83 C76.8,49.41,81.2,45.01,86.63,45.01L86.63,45.01z M6.76,0h109.36c1.86,0,3.55,0.76,4.77,1.98c1.22,1.22,1.98,2.92,1.98,4.77v64.7 c0,1.86-0.76,3.55-1.98,4.77c-1.22,1.22-2.91,1.99-4.77,1.99H6.76c-1.86,0-3.55-0.76-4.77-1.98C0.76,75.01,0,73.32,0,71.46V6.76 C0,4.9,0.76,3.21,1.98,1.98C3.21,0.76,4.9,0,6.76,0L6.76,0z M16.66,51.66c-1.08,0-1.96-0.88-1.96-1.96c0-1.08,0.88-1.96,1.96-1.96 h32.95c1.08,0,1.96,0.88,1.96,1.96c0,1.08-0.88,1.96-1.96,1.96H16.66L16.66,51.66z M16.66,61.94c-1.08,0-1.96-0.88-1.96-1.96 c0-1.08,0.88-1.96,1.96-1.96h22.23c1.08,0,1.96,0.88,1.96,1.96c0,1.08-0.88,1.96-1.96,1.96H16.66L16.66,61.94z M3.91,14.56h115.05 v-7.8c0-0.78-0.32-1.49-0.84-2.01c-0.52-0.52-1.23-0.84-2.01-0.84H6.76c-0.78,0-1.49,0.32-2.01,0.84C4.23,5.27,3.91,5.98,3.91,6.76 V14.56L3.91,14.56z M118.97,33.99H3.91v37.47c0,0.78,0.32,1.49,0.84,2.01c0.52,0.52,1.23,0.84,2.01,0.84h109.36 c0.78,0,1.49-0.32,2.01-0.84c0.52-0.52,0.84-1.23,0.84-2.01V33.99L118.97,33.99z"></path></g></svg>
                <i class="bi bi-credit-card-2-back"></i>${masked_pan}
              </span>`
                    : ""
            }
            </div>
            ${linkHTML}
          </div>
          <div>
            <span class="badge text-uppercase ${badgeColorByPlan(sub.plan)}">${sub.plan}</span>
            <span class="badge bg-success ms-2 text-uppercase">${sub.status}</span>
          </div>
        </div>
      </div>

      <!-- Дата продления -->
      <div class="card p-3 mb-4">
        <p class="text-muted small mb-0">${dateTitle}</p>
        <span class="big fw-bold">${fmtDate(sub.next_payment)}</span>
      </div>

      <!-- Usage -->
      <h6 class="fw-semibold mb-1">${usageTitle}</h6>
      <p class="text-muted small mb-1">${usageRenewalPeriodText}</p>
      <div class="row">
        <!-- Accounts -->
        <div class="col-12 col-md-6 mb-3">
          <div class="card p-3">
            <p class="text-muted small mb-0">${accountsTitle}</p>
            <span class="big fw-bold">
              ${accountsFree.toLocaleString()} ${ofTitle} ${accountsLimit.toLocaleString()}
            </span>
            ${
                (() => {
                    const pct = progressPercent(accountsFree, accountsLimit)
                    return /* html */ `
              <div class="progress mt-2" style="height: 10px;">
                <div class="progress-bar ${progressColor(
                        pct
                    )}" style="width:${pct}%"></div>
              </div>`;
                })()
            }
          </div>
        </div>

        <!-- Connections -->
        <div class="col-12 col-md-6 mb-3">
          <div class="card p-3">
            <p class="text-muted small mb-0">${connectionsTitle}</p>
            <span class="big fw-bold">
              ${sub.connections_free} ${ofTitle} ${sub.connections_all}
            </span>
            ${
                (() => {
                    const pct = progressPercent(sub.connections_free, sub.connections_all)
                    return /* html */ `
              <div class="progress mt-2" style="height: 10px;">
                <div class="progress-bar ${progressColor(
                        pct
                    )}" style="width:${pct}%"></div>
              </div>`;
                })()
            }
          </div>
        </div>

        <!-- Tokens -->
        <div class="col-12 mb-3">
          <div class="card p-3">
            <p class="text-muted small mb-0">${tokensTitle}</p>
            <span class="big fw-bold">
              ${sub.tokens_left.toLocaleString()} ${ofTitle} ${sub.token_all.toLocaleString()}
            </span>
            ${
                (() => {
                    const pct = progressPercent(sub.tokens_left, sub.token_all)
                    return /* html */ `
              <div class="progress mt-2" style="height: 10px;">
                <div class="progress-bar ${progressColor(
                        pct
                    )}" style="width:${pct}%"></div>
              </div>`;
                })()
            }
          </div>
        </div>
      </div>
      `
            : /* html */ `
      `
    }
    
  `;
}


export function setSubscribeBtnText(data) {
    const subscribeBtn = $("#manageSubscriptionSubscribeBtn")
    const btnText = data.current_subscription && data.current_subscription.auto_renew ? i18next.t('common:dom.upgradeBtnText') : i18next.t('common:dom.subscribeBtnText');
    subscribeBtn.text(btnText)
}


const SVG_ICONS = {
    'generic': `<svg version="1.1" width="26px" height="26px"  id="generic-outline-large" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
\t viewBox="0 0 48 32" enable-background="new 0 0 48 32" xml:space="preserve">
<g id="generic-outline-large_1_" transform="translate(1104.000000, 564.000000)">
\t<path fill="none" d="M-1100-564h40c2.2,0,4,1.8,4,4v24c0,2.2-1.8,4-4,4h-40c-2.2,0-4-1.8-4-4v-24C-1104-562.2-1102.2-564-1100-564z
\t\t"/>
\t<path fill="currentColor" d="M-1060-562c1.1,0,2,0.9,2,2v24c0,1.1-0.9,2-2,2h-40c-1.1,0-2-0.9-2-2v-24c0-1.1,0.9-2,2-2H-1060z
\t\t M-1060-564h-40c-2.2,0-4,1.8-4,4v24c0,2.2,1.8,4,4,4h40c2.2,0,4-1.8,4-4v-24C-1056-562.2-1057.8-564-1060-564z"/>
</g>
</svg>`,

    'Visa': `<svg version="1.1" width="26px" height="26px"  id="visa-outline-large" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
\t viewBox="0 0 48 32" enable-background="new 0 0 48 32" xml:space="preserve">
<g id="visa-outline-large_1_" transform="translate(96.000000, 564.000000)">
\t<path fill="none" d="M-92-564h40c2.2,0,4,1.8,4,4v24c0,2.2-1.8,4-4,4h-40c-2.2,0-4-1.8-4-4v-24C-96-562.2-94.2-564-92-564z"/>
\t<path fill="currentColor" d="M-52-562c1.1,0,2,0.9,2,2v24c0,1.1-0.9,2-2,2h-40c-1.1,0-2-0.9-2-2v-24c0-1.1,0.9-2,2-2H-52z M-52-564h-40
\t\tc-2.2,0-4,1.8-4,4v24c0,2.2,1.8,4,4,4h40c2.2,0,4-1.8,4-4v-24C-48-562.2-49.8-564-52-564z"/>
\t<path fill="currentColor" d="M-72.1-552.6l-2,9.2h-2.4l2-9.2H-72.1z M-62.1-546.6l1.3-3.5l0.7,3.5H-62.1z M-59.4-543.3h2.2l-1.9-9.2h-2
\t\tc-0.4,0-0.8,0.3-1,0.7l-3.6,8.6h2.5l0.5-1.4h3L-59.4-543.3z M-65.7-546.3c0-2.5-3.3-2.7-3.3-3.7c0-0.3,0.3-0.7,1-0.8
\t\tc0.8-0.1,1.6,0.1,2.4,0.4l0.4-2c-0.7-0.3-1.5-0.4-2.2-0.4c-2.4,0-4,1.3-4,3.1c0,1.3,1.2,2.1,2.1,2.5s1.2,0.8,1.2,1.2
\t\tc0,0.6-0.7,0.9-1.4,0.9c-0.9,0-1.7-0.2-2.4-0.6l-0.4,2c0.8,0.3,1.8,0.5,2.7,0.5C-67.3-543.2-65.6-544.5-65.7-546.3 M-75.5-552.6
\t\tl-3.9,9.2H-82l-1.9-7.4c0-0.4-0.3-0.7-0.6-0.8c-0.8-0.4-1.5-0.6-2.4-0.8l0.1-0.3h4.1c0.6,0,1,0.4,1.1,0.9l1,5.4l2.5-6.3H-75.5z"/>
</g>
</svg>`,

    'Mastercard': `<svg version="1.1" width="26px" height="26px"  id="mastercard-outline-large" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
\t viewBox="0 0 48 32" enable-background="new 0 0 48 32" xml:space="preserve">
<g id="mastercard-outline-large_1_" transform="translate(208.000000, 564.000000)">
\t<path fill="none" d="M-204-564h40c2.2,0,4,1.8,4,4v24c0,2.2-1.8,4-4,4h-40c-2.2,0-4-1.8-4-4v-24C-208-562.2-206.2-564-204-564z"/>
\t<path fill="currentColor" d="M-164-562c1.1,0,2,0.9,2,2v24c0,1.1-0.9,2-2,2h-40c-1.1,0-2-0.9-2-2v-24c0-1.1,0.9-2,2-2H-164z M-164-564
\t\th-40c-2.2,0-4,1.8-4,4v24c0,2.2,1.8,4,4,4h40c2.2,0,4-1.8,4-4v-24C-160-562.2-161.8-564-164-564z"/>
\t<g transform="translate(4.000000, 3.000000)">
\t\t<g opacity="0">
\t\t\t<rect x="-207.4" y="-563.8" fill="currentColor" width="38.7" height="25.6"/>
\t\t</g>
\t\t<path fill="currentColor" d="M-189.8-541.5c-4.5,2.3-9.9,1.1-13.1-2.8s-3.1-9.5,0-13.3s8.6-5.1,13.1-2.8c-2.7,2.4-4.3,5.8-4.3,9.5
\t\t\tC-194.1-547.4-192.5-543.9-189.8-541.5z"/>
\t\t<path fill="currentColor" d="M-171.9-544.4v-0.3h0.2v-0.1h-0.4v0.1h0.1L-171.9-544.4L-171.9-544.4z M-171.2-544.4v-0.4h-0.1l-0.1,0.3
\t\t\tl-0.1-0.3h-0.1v0.4h0.1v-0.3l0.1,0.3h0.1l0.1-0.3L-171.2-544.4L-171.2-544.4z"/>
\t\t<path fill="currentColor" d="M-170.8-551c0,3.7-1.9,7.1-5,9c-3.1,1.9-7,2.1-10.3,0.4c5-4.4,5.7-12,1.6-17.3c-0.5-0.6-1-1.2-1.6-1.7
\t\t\tc3.3-1.7,7.2-1.5,10.4,0.4C-172.7-558.1-170.8-554.7-170.8-551z"/>
\t\t<path fill="currentColor" d="M-188-542.7c-2.6-2-4.1-5.1-4.1-8.3s1.5-6.3,4.1-8.3c2.6,2,4.1,5.1,4.1,8.3S-185.4-544.7-188-542.7
\t\t\tL-188-542.7z"/>
\t</g>
</g>
</svg>`,

    'Amex': `<svg version="1.1" width="26px" height="26px"  id="americanexpress-outline-large" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
\t viewBox="0 0 48 32" enable-background="new 0 0 48 32" xml:space="preserve">
<g id="americanexpress-outline-large_1_" transform="translate(320.000000, 564.000000)">
\t<path fill="none" d="M-316-564h40c2.2,0,4,1.8,4,4v24c0,2.2-1.8,4-4,4h-40c-2.2,0-4-1.8-4-4v-24C-320-562.2-318.2-564-316-564z"/>
\t<path fill="currentColor" d="M-276-562c1.1,0,2,0.9,2,2v24c0,1.1-0.9,2-2,2h-40c-1.1,0-2-0.9-2-2v-24c0-1.1,0.9-2,2-2H-276z M-276-564
\t\th-40c-2.2,0-4,1.8-4,4v24c0,2.2,1.8,4,4,4h40c2.2,0,4-1.8,4-4v-24C-272-562.2-273.8-564-276-564z"/>
\t<g transform="translate(2.000000, 7.000000)">
\t\t<polygon fill="currentColor" points="-316.7,-560.6 -316.2,-559.4 -317.8,-559.4 -317.3,-560.6 -317,-561.4 \t\t"/>
\t\t<path fill="currentColor" d="M-298.6-561.4h-1.4v1.1h1.5c0.2,0,0.3,0,0.5-0.1c0.1-0.1,0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4
\t\t\tS-298.4-561.4-298.6-561.4L-298.6-561.4z M-298.6-561.4h-1.4v1.1h1.5c0.2,0,0.3,0,0.5-0.1c0.1-0.1,0.2-0.3,0.2-0.4
\t\t\tc0-0.2-0.1-0.3-0.2-0.4S-298.4-561.4-298.6-561.4L-298.6-561.4z M-298.6-561.4h-1.4v1.1h1.5c0.2,0,0.3,0,0.5-0.1
\t\t\tc0.1-0.1,0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4S-298.4-561.4-298.6-561.4L-298.6-561.4z M-287.6-560.6l-0.4-0.8l0,0l-0.3,0.8
\t\t\tl-0.5,1.2h1.6L-287.6-560.6z M-287.6-560.6l-0.4-0.8l0,0l-0.3,0.8l-0.5,1.2h1.6L-287.6-560.6z M-298.6-561.4h-1.4v1.1h1.5
\t\t\tc0.2,0,0.3,0,0.5-0.1c0.1-0.1,0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4S-298.4-561.4-298.6-561.4L-298.6-561.4z M-298.6-561.4h-1.4
\t\t\tv1.1h1.5c0.2,0,0.3,0,0.5-0.1c0.1-0.1,0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4S-298.4-561.4-298.6-561.4L-298.6-561.4z
\t\t\t M-287.6-560.6l-0.4-0.8l0,0l-0.3,0.8l-0.5,1.2h1.6L-287.6-560.6z M-287.6-560.6l-0.4-0.8l0,0l-0.3,0.8l-0.5,1.2h1.6L-287.6-560.6
\t\t\tz M-298.6-561.4h-1.4v1.1h1.5c0.2,0,0.3,0,0.5-0.1c0.1-0.1,0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4S-298.4-561.4-298.6-561.4
\t\t\tL-298.6-561.4z M-298.6-561.4h-1.4v1.1h1.5c0.2,0,0.3,0,0.5-0.1c0.1-0.1,0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4
\t\t\tS-298.4-561.4-298.6-561.4L-298.6-561.4z M-287.6-560.6l-0.4-0.8l0,0l-0.3,0.8l-0.5,1.2h1.6L-287.6-560.6z M-287.6-560.6l-0.4-0.8
\t\t\tl0,0l-0.3,0.8l-0.5,1.2h1.6L-287.6-560.6z M-298.6-561.4h-1.4v1.1h1.5c0.2,0,0.3,0,0.5-0.1c0.1-0.1,0.2-0.3,0.2-0.4
\t\t\tc0-0.2-0.1-0.3-0.2-0.4S-298.4-561.4-298.6-561.4L-298.6-561.4z M-298.6-561.4h-1.4v1.1h1.5c0.2,0,0.3,0,0.5-0.1
\t\t\tc0.1-0.1,0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4S-298.4-561.4-298.6-561.4L-298.6-561.4z M-287.6-560.6l-0.4-0.8l0,0l-0.3,0.8
\t\t\tl-0.5,1.2h1.6L-287.6-560.6z M-287.6-560.6l-0.4-0.8l0,0l-0.3,0.8l-0.5,1.2h1.6L-287.6-560.6z M-298.6-561.4h-1.4v1.1h1.5
\t\t\tc0.2,0,0.3,0,0.5-0.1c0.1-0.1,0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4S-298.4-561.4-298.6-561.4L-298.6-561.4z M-298.6-561.4h-1.4
\t\t\tv1.1h1.5c0.2,0,0.3,0,0.5-0.1c0.1-0.1,0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4S-298.4-561.4-298.6-561.4L-298.6-561.4z
\t\t\t M-287.6-560.6l-0.4-0.8l0,0l-0.3,0.8l-0.5,1.2h1.6L-287.6-560.6z M-287.6-560.6l-0.4-0.8l0,0l-0.3,0.8l-0.5,1.2h1.6L-287.6-560.6
\t\t\tz M-298.6-561.4h-1.4v1.1h1.5c0.2,0,0.3,0,0.5-0.1c0.1-0.1,0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4S-298.4-561.4-298.6-561.4
\t\t\tL-298.6-561.4z M-281.8-563.7v1.5l-1-1.5h-2.9v1.9l-0.9-1.9h-4.9c-0.8,0-1.6,0.2-2.3,0.8v-0.8h-16.1l-0.6,1.7l-0.5-1.7h-3.7v1.9
\t\t\tl-0.9-1.9h-3l-1.5,3.4v4.1h2.1l0.4-1.1h1l0.5,1.1h16.8v-1.3l1.1,1.3h4.4v-0.7c0.6,0.5,1.4,0.7,2.2,0.7h2.6l0.4-1.1h1l0.5,1.1h4.5
\t\t\tv-1.4l0.9,1.4h3.1v-7.5H-281.8z M-315.3-557.3l-0.4-1.1h-2.4l-0.4,1.1h-1.4l2.2-5.2h1.6l2.2,5.2H-315.3z M-307.2-557.3h-1.2v-3.4
\t\t\tv-0.8l0,0l-0.2,0.8l-1.2,3.4h-1.1l-1.2-3.4l-0.3-0.8l0,0v0.8v3.4h-1.2v-5.2h2l1,3l0.2,0.6l0,0l0.2-0.6l1-3h2L-307.2-557.3z
\t\t\t M-302.1-561.4h-2.9v0.9h2.8v1.1h-2.8v1h2.9v1.1h-4.2v-5.2h4.1V-561.4z M-297.9-557.3l-1.5-1.8h-0.5v1.8h-1.3v-5.2h2.8
\t\t\tc0.5,0,0.9,0.1,1.3,0.4c0.3,0.3,0.5,0.8,0.5,1.2c0,0.8-0.6,1.5-1.4,1.6l1.7,1.9H-297.9z M-294.8-557.3h-1.2v-5.2h1.2V-557.3z
\t\t\t M-291.6-557.3L-291.6-557.3c-0.8,0-1.4-0.2-1.9-0.7c-0.5-0.5-0.7-1.2-0.6-1.8v-0.1c-0.1-0.7,0.2-1.4,0.7-1.9
\t\t\tc0.5-0.5,1.1-0.8,1.8-0.7h1.5v1.1h-1.3c-0.4,0-0.7,0.1-1,0.4c-0.3,0.3-0.4,0.7-0.3,1v0.1c0,0.4,0.1,0.8,0.3,1
\t\t\tc0.3,0.3,0.6,0.4,1,0.4h0.4L-291.6-557.3z M-286.3-557.3l-0.4-1.1h-2.5l-0.4,1.1h-1.4l2.2-5.2h1.7l2.2,5.2H-286.3z M-279.7-557.3
\t\t\th-1.5l-1.9-2.9l-0.3-0.6l0,0v3.5h-1.2v-5.2h1.5l1.8,2.8l0.4,0.6l0,0v-3.4h1.2V-557.3z M-288-561.4L-288-561.4l-0.3,0.8l-0.5,1.2
\t\t\th1.6l-0.5-1.2L-288-561.4z M-298.6-561.4h-1.4v1.1h1.5c0.2,0,0.3,0,0.5-0.1c0.1-0.1,0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4
\t\t\tC-298.3-561.4-298.4-561.4-298.6-561.4L-298.6-561.4z M-298.6-561.4h-1.4v1.1h1.5c0.2,0,0.3,0,0.5-0.1c0.1-0.1,0.2-0.3,0.2-0.4
\t\t\tc0-0.2-0.1-0.3-0.2-0.4C-298.3-561.4-298.4-561.4-298.6-561.4L-298.6-561.4z M-287.7-560.7l-0.3-0.8l0,0l-0.3,0.8l-0.5,1.2h1.6
\t\t\tL-287.7-560.7z M-287.7-560.7l-0.3-0.8l0,0l-0.3,0.8l-0.5,1.2h1.6L-287.7-560.7z M-298.6-561.4h-1.4v1.1h1.5c0.2,0,0.3,0,0.5-0.1
\t\t\tc0.1-0.1,0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4S-298.4-561.4-298.6-561.4L-298.6-561.4z M-298.6-561.4h-1.4v1.1h1.5
\t\t\tc0.2,0,0.3,0,0.5-0.1c0.1-0.1,0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4S-298.4-561.4-298.6-561.4L-298.6-561.4z M-287.6-560.6
\t\t\tl-0.4-0.8l0,0l-0.3,0.8l-0.5,1.2h1.6L-287.6-560.6z M-287.6-560.6l-0.4-0.8l0,0l-0.3,0.8l-0.5,1.2h1.6L-287.6-560.6z
\t\t\t M-298.6-561.4h-1.4v1.1h1.5c0.2,0,0.3,0,0.5-0.1c0.1-0.1,0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4S-298.4-561.4-298.6-561.4
\t\t\tL-298.6-561.4z M-298.6-561.4h-1.4v1.1h1.5c0.2,0,0.3,0,0.5-0.1c0.1-0.1,0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4
\t\t\tS-298.4-561.4-298.6-561.4L-298.6-561.4z M-287.6-560.6l-0.4-0.8l0,0l-0.3,0.8l-0.5,1.2h1.6L-287.6-560.6z M-287.6-560.6l-0.4-0.8
\t\t\tl0,0l-0.3,0.8l-0.5,1.2h1.6L-287.6-560.6z M-298.6-561.4h-1.4v1.1h1.5c0.2,0,0.3,0,0.5-0.1c0.1-0.1,0.2-0.3,0.2-0.4
\t\t\tc0-0.2-0.1-0.3-0.2-0.4S-298.4-561.4-298.6-561.4L-298.6-561.4z M-298.6-561.4h-1.4v1.1h1.5c0.2,0,0.3,0,0.5-0.1
\t\t\tc0.1-0.1,0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4S-298.4-561.4-298.6-561.4L-298.6-561.4z M-287.6-560.6l-0.4-0.8l0,0l-0.3,0.8
\t\t\tl-0.5,1.2h1.6L-287.6-560.6z M-287.6-560.6l-0.4-0.8l0,0l-0.3,0.8l-0.5,1.2h1.6L-287.6-560.6z M-298.6-561.4h-1.4v1.1h1.5
\t\t\tc0.2,0,0.3,0,0.5-0.1c0.1-0.1,0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4S-298.4-561.4-298.6-561.4L-298.6-561.4z M-298.6-561.4h-1.4
\t\t\tv1.1h1.5c0.2,0,0.3,0,0.5-0.1c0.1-0.1,0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4S-298.4-561.4-298.6-561.4L-298.6-561.4z
\t\t\t M-298.6-561.4h-1.4v1.1h1.5c0.2,0,0.3,0,0.5-0.1c0.1-0.1,0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4S-298.4-561.4-298.6-561.4
\t\t\tL-298.6-561.4z M-298.6-561.4h-1.4v1.1h1.5c0.2,0,0.3,0,0.5-0.1c0.1-0.1,0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4
\t\t\tS-298.4-561.4-298.6-561.4L-298.6-561.4z M-298.6-561.4h-1.4v1.1h1.5c0.2,0,0.3,0,0.5-0.1c0.1-0.1,0.2-0.3,0.2-0.4
\t\t\tc0-0.2-0.1-0.3-0.2-0.4S-298.4-561.4-298.6-561.4L-298.6-561.4z"/>
\t\t<path fill="currentColor" d="M-297.7-551.6h-1.5v1.3h1.5c0.2,0,0.3-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5c0-0.2-0.1-0.3-0.2-0.5
\t\t\tC-297.4-551.5-297.5-551.6-297.7-551.6z M-297.7-551.6h-1.5v1.3h1.5c0.2,0,0.3-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5
\t\t\tc0-0.2-0.1-0.3-0.2-0.5C-297.4-551.5-297.5-551.6-297.7-551.6z M-297.7-551.6h-1.5v1.3h1.5c0.2,0,0.3-0.1,0.5-0.2
\t\t\tc0.1-0.1,0.2-0.3,0.2-0.5c0-0.2-0.1-0.3-0.2-0.5C-297.4-551.5-297.5-551.6-297.7-551.6z M-292.4-551.6h-1.4v1.1h1.4
\t\t\tc0.2,0,0.3,0,0.4-0.1s0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4C-292.1-551.6-292.3-551.6-292.4-551.6z M-292.4-551.6h-1.4v1.1h1.4
\t\t\tc0.2,0,0.3,0,0.4-0.1s0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4C-292.1-551.6-292.3-551.6-292.4-551.6z M-297.7-551.6h-1.5v1.3h1.5
\t\t\tc0.2,0,0.3-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5c0-0.2-0.1-0.3-0.2-0.5C-297.4-551.5-297.5-551.6-297.7-551.6z M-297.7-551.6h-1.5
\t\t\tv1.3h1.5c0.2,0,0.3-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5c0-0.2-0.1-0.3-0.2-0.5C-297.4-551.5-297.5-551.6-297.7-551.6z
\t\t\t M-292.4-551.6h-1.4v1.1h1.4c0.2,0,0.3,0,0.4-0.1s0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4C-292.1-551.6-292.3-551.6-292.4-551.6z
\t\t\t M-276.4-551.6h-2.3c-0.1,0-0.3,0-0.4,0.1c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.3,0.1,0.4c0.1,0.1,0.2,0.1,0.4,0.1h1.2
\t\t\tc0.6-0.1,1.2,0.3,1.5,0.9v-2.9L-276.4-551.6z M-292.4-551.6h-1.5v1.1h1.4c0.2,0,0.3,0,0.4-0.1s0.2-0.3,0.2-0.4
\t\t\tc0-0.2-0.1-0.3-0.2-0.4C-292.1-551.6-292.3-551.6-292.4-551.6L-292.4-551.6z M-297.7-551.6h-1.5v1.3h1.5c0.2,0,0.3-0.1,0.5-0.2
\t\t\tc0.1-0.1,0.2-0.3,0.2-0.5c0-0.2-0.1-0.3-0.2-0.5C-297.4-551.5-297.5-551.6-297.7-551.6L-297.7-551.6z M-278.7-552.7h2.7v-1.2
\t\t\th-26.7l-0.8,1.1l-0.8-1.1h-7.6v7.5h7.6l0.8-1.1l0.8,1.1h4.6v-1.7h0.5c0.5,0,0.9-0.1,1.4-0.2v1.9h3.2v-1.4l1.1,1.3h14.3
\t\t\tc0.6,0,1.2-0.1,1.7-0.5v-1.8c-0.3,0.7-1,1.1-1.7,1h-2.6v-1.1h2.6c0.3,0,0.5-0.2,0.5-0.5s-0.2-0.5-0.5-0.5h-1.2
\t\t\tc-0.4,0.1-0.9-0.1-1.2-0.4c-0.3-0.3-0.5-0.7-0.5-1.1c0-0.5,0.2-0.9,0.6-1.2S-279.1-552.7-278.7-552.7z M-306.5-551.6h-2.9v0.9h2.9
\t\t\tv1.1h-2.9v1h2.9v1.1h-4.2v-5.2h4.2V-551.6z M-302.3-547.5l-1.2-1.7l-1.3,1.7h-1.5l2.1-2.6l-2.1-2.6h1.6l1.3,1.6l1.3-1.6h1.5
\t\t\tl-2.1,2.6l2.1,2.6H-302.3z M-297.6-549.2h-1.6v1.7h-1.2v-5.2h2.9c0.5,0,0.9,0.1,1.3,0.4s0.5,0.8,0.5,1.2c0,0.5-0.2,1-0.5,1.3
\t\t\tC-296.7-549.4-297.2-549.2-297.6-549.2L-297.6-549.2z M-291.8-547.5l-1.5-1.9h-0.6v1.9h-1.2v-5.2h2.8c0.9,0,1.6,0.6,1.7,1.5
\t\t\tc0.1,0.9-0.5,1.7-1.3,1.8l1.7,1.9H-291.8z M-285.8-551.6h-2.9v0.9h2.8v1.1h-2.8v1h2.9v1.1h-4.2v-5.2h4.2L-285.8-551.6z
\t\t\t M-282.5-547.5h-2.6v-1.1h2.6c0.3,0,0.5-0.2,0.5-0.5s-0.2-0.5-0.5-0.5h-1.2c-0.4,0.1-0.9-0.1-1.2-0.4c-0.3-0.3-0.5-0.7-0.5-1.1
\t\t\tc0-0.5,0.2-0.9,0.5-1.2c0.3-0.3,0.8-0.5,1.3-0.4h2.7l-0.5,1.1h-2.2c-0.1,0-0.3,0-0.4,0.1s-0.1,0.2-0.1,0.3c0,0.1,0,0.3,0.1,0.4
\t\t\tc0.1,0.1,0.2,0.1,0.4,0.1h1.2c0.4-0.1,0.8,0.1,1.2,0.4s0.5,0.7,0.5,1.1c0,0.5-0.2,0.9-0.5,1.2C-281.5-547.6-282-547.5-282.5-547.5
\t\t\tL-282.5-547.5z M-292.5-551.6h-1.4v1.1h1.4c0.2,0,0.3,0,0.4-0.1s0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4
\t\t\tC-292.1-551.6-292.3-551.6-292.5-551.6L-292.5-551.6z M-297.8-551.6h-1.4v1.3h1.5c0.2,0,0.3-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5
\t\t\tc0-0.2-0.1-0.3-0.2-0.5C-297.4-551.5-297.5-551.6-297.8-551.6L-297.8-551.6z M-297.8-551.6h-1.4v1.3h1.5c0.2,0,0.3-0.1,0.5-0.2
\t\t\tc0.1-0.1,0.2-0.3,0.2-0.5c0-0.2-0.1-0.3-0.2-0.5C-297.4-551.5-297.5-551.6-297.8-551.6L-297.8-551.6z M-292.5-551.6h-1.4v1.1h1.4
\t\t\tc0.2,0,0.3,0,0.4-0.1s0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4C-292.1-551.6-292.3-551.6-292.5-551.6L-292.5-551.6z M-292.5-551.6
\t\t\th-1.4v1.1h1.4c0.2,0,0.3,0,0.4-0.1s0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4C-292.1-551.6-292.3-551.6-292.5-551.6L-292.5-551.6z
\t\t\t M-297.8-551.6h-1.4v1.3h1.5c0.2,0,0.3-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5c0-0.2-0.1-0.3-0.2-0.5
\t\t\tC-297.4-551.5-297.5-551.6-297.8-551.6L-297.8-551.6z M-297.8-551.6h-1.4v1.3h1.5c0.2,0,0.3-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5
\t\t\tc0-0.2-0.1-0.3-0.2-0.5C-297.4-551.5-297.5-551.6-297.8-551.6L-297.8-551.6z M-292.5-551.6h-1.4v1.1h1.4c0.2,0,0.3,0,0.4-0.1
\t\t\ts0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4C-292.1-551.6-292.3-551.6-292.5-551.6L-292.5-551.6z M-292.5-551.6h-1.4v1.1h1.4
\t\t\tc0.2,0,0.3,0,0.4-0.1s0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4C-292.1-551.6-292.3-551.6-292.5-551.6L-292.5-551.6z M-297.8-551.6
\t\t\th-1.4v1.3h1.5c0.2,0,0.3-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5c0-0.2-0.1-0.3-0.2-0.5C-297.4-551.5-297.5-551.6-297.8-551.6
\t\t\tL-297.8-551.6z"/>
\t</g>
</g>
</svg>`,

    'Discover': `<svg version="1.1" width="26px" height="26px"  id="discover-outline-large" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
\t viewBox="0 0 48 32" enable-background="new 0 0 48 32" xml:space="preserve">
<g id="discover-outline-large_1_" transform="translate(544.000000, 564.000000)">
\t<path fill="none" d="M-540-564h40c2.2,0,4,1.8,4,4v24c0,2.2-1.8,4-4,4h-40c-2.2,0-4-1.8-4-4v-24C-544-562.2-542.2-564-540-564z"/>
\t<path fill="currentColor" d="M-500-562c1.1,0,2,0.9,2,2v24c0,1.1-0.9,2-2,2h-40c-1.1,0-2-0.9-2-2v-24c0-1.1,0.9-2,2-2H-500z M-500-564
\t\th-40c-2.2,0-4,1.8-4,4v24c0,2.2,1.8,4,4,4h40c2.2,0,4-1.8,4-4v-24C-496-562.2-497.8-564-500-564z"/>
\t<g transform="translate(4.000000, 10.000000)">
\t\t<path fill="currentColor" d="M-502-556.3v10.3c0,1.1-0.9,2-2,2h-32.1C-514-547.8-502-556.3-502-556.3z"/>
\t\t<path fill="currentColor" d="M-542.2-563.4h-1.8v6.4h1.8c0.8,0,1.6-0.2,2.3-0.7c0.7-0.6,1.1-1.5,1.2-2.5c0-0.9-0.4-1.8-1-2.4
\t\t\tS-541.3-563.4-542.2-563.4z M-540.7-558.5c-0.5,0.4-1.1,0.6-1.7,0.5h-0.3v-4.3h0.3c0.6-0.1,1.2,0.1,1.7,0.5c0.5,0.4,0.7,1,0.7,1.6
\t\t\tC-540-559.6-540.3-559-540.7-558.5z"/>
\t\t<rect x="-538.2" y="-563.4" fill="currentColor" width="1.2" height="6.4"/>
\t\t<path fill="currentColor" d="M-533.8-560.9c-0.8-0.3-1-0.5-1-0.8c0-0.3,0.4-0.7,0.9-0.7c0.4,0,0.8,0.2,1,0.5l0.7-0.9
\t\t\tc-0.5-0.5-1.2-0.7-1.9-0.7c-0.5,0-1,0.1-1.4,0.5c-0.4,0.3-0.6,0.8-0.6,1.3c0,0.9,0.4,1.3,1.6,1.8c0.3,0.1,0.6,0.2,0.9,0.4
\t\t\tc0.2,0.1,0.4,0.4,0.4,0.7c0,0.3-0.1,0.5-0.3,0.7c-0.2,0.2-0.4,0.3-0.7,0.2c-0.6,0-1.1-0.3-1.4-0.9l-0.8,0.8
\t\t\tc0.5,0.8,1.4,1.3,2.3,1.2c0.6,0,1.1-0.2,1.6-0.6c0.4-0.4,0.6-1,0.6-1.5C-532-559.9-532.4-560.4-533.8-560.9z"/>
\t\t<path fill="currentColor" d="M-531.6-560.2c0,0.9,0.3,1.8,1,2.4s1.5,1,2.4,1c0.5,0,1.1-0.1,1.6-0.4v-1.5c-0.4,0.4-0.9,0.7-1.5,0.7
\t\t\tc-0.6,0-1.2-0.2-1.6-0.6c-0.4-0.4-0.6-1-0.6-1.6c0-0.6,0.2-1.1,0.6-1.5s0.9-0.7,1.5-0.7c0.6,0,1.2,0.3,1.6,0.7v-1.5
\t\t\tc-0.5-0.3-1-0.4-1.5-0.4c-0.9,0-1.8,0.3-2.4,1C-531.2-561.9-531.6-561.1-531.6-560.2L-531.6-560.2z"/>
\t\t<polygon fill="currentColor" points="-516.7,-559.1 -518.4,-563.4 -519.8,-563.4 -517.1,-556.8 -516.4,-556.8 -513.6,-563.4 
\t\t\t-515,-563.4 \t\t"/>
\t\t<polygon fill="currentColor" points="-513,-557 -509.5,-557 -509.5,-558 -511.8,-558 -511.8,-559.8 -509.6,-559.8 -509.6,-560.9 
\t\t\t-511.8,-560.9 -511.8,-562.3 -509.5,-562.3 -509.5,-563.4 -513,-563.4 \t\t"/>
\t\t<path fill="currentColor" d="M-506-559.7c0.9-0.1,1.5-0.9,1.5-1.8c0-1.2-0.8-1.9-2.3-1.9h-1.9v6.4h1.2v-2.6h0.1l1.7,2.6h1.5L-506-559.7
\t\t\tz M-507-560.4h-0.4v-1.9h0.4c0.8,0,1.2,0.3,1.2,1S-506.2-560.4-507-560.4z"/>
\t\t<path fill="currentColor" d="M-519.4-560.2c0,1.9-1.5,3.4-3.4,3.4s-3.4-1.5-3.4-3.4c0-1.9,1.5-3.4,3.4-3.4
\t\t\tC-520.9-563.6-519.4-562-519.4-560.2L-519.4-560.2z"/>
\t\t<path fill="currentColor" d="M-504-563.1c0.1,0,0.1-0.1,0.1-0.2c0-0.1-0.1-0.2-0.2-0.2h-0.2v0.6h0.1v-0.2l0.2,0.2h0.1L-504-563.1z
\t\t\t M-504.1-563.2L-504.1-563.2v-0.1l0,0c0.1,0,0.1,0,0.1,0.1S-504-563.2-504.1-563.2L-504.1-563.2z"/>
\t\t<path fill="currentColor" d="M-504.1-563.6c-0.1,0-0.3,0.1-0.3,0.2c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.3,0.2,0.5,0.5,0.5
\t\t\tc0.3,0,0.5-0.2,0.5-0.5c0-0.1-0.1-0.3-0.2-0.4S-503.9-563.6-504.1-563.6z M-503.8-562.8c-0.1,0.1-0.2,0.1-0.2,0.1
\t\t\tc-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1
\t\t\ts0.1,0.2,0.1,0.3C-503.7-563-503.7-562.9-503.8-562.8L-503.8-562.8z"/>
\t</g>
</g>
</svg>`,

    'UnionPay': `<svg version="1.1" width="26px" height="26px"  id="union-pay-outline-large" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
\t viewBox="0 0 48 32" enable-background="new 0 0 48 32" xml:space="preserve">
<g id="union-pay-outline-large_1_" transform="translate(1104.000000, 564.000000)">
\t<path fill="none" d="M-1100-564h40c2.2,0,4,1.8,4,4v24c0,2.2-1.8,4-4,4h-40c-2.2,0-4-1.8-4-4v-24C-1104-562.2-1102.2-564-1100-564z
\t\t"/>
\t<path fill="currentColor" d="M-1060-562c1.1,0,2,0.9,2,2v24c0,1.1-0.9,2-2,2h-40c-1.1,0-2-0.9-2-2v-24c0-1.1,0.9-2,2-2H-1060z
\t\t M-1060-564h-40c-2.2,0-4,1.8-4,4v24c0,2.2,1.8,4,4,4h40c2.2,0,4-1.8,4-4v-24C-1056-562.2-1057.8-564-1060-564z"/>
</g>
<g>
\t<path fill="currentColor" d="M8.3,6.8h1.3l-0.7,3.5l-0.2,0.9c0,0.1,0,0.1,0,0.2c0,0.3,0.1,0.5,0.3,0.6c0.2,0.2,0.5,0.2,0.8,0.2c0.3,0,0.6-0.1,0.8-0.2
\t\ts0.4-0.3,0.5-0.5s0.2-0.6,0.3-1.2l0.7-3.5h1.3l-0.7,3.5c-0.2,0.7-0.3,1.3-0.5,1.7s-0.5,0.7-0.9,1s-0.9,0.4-1.6,0.4
\t\tc-0.8,0-1.3-0.2-1.7-0.6S7.4,12,7.4,11.4c0-0.1,0-0.3,0-0.4c0-0.1,0.1-0.4,0.2-0.8L8.3,6.8z"/>
\t<path fill="currentColor" d="M14,8.6h1.2l-0.1,0.6c0.3-0.3,0.6-0.4,0.8-0.6c0.3-0.1,0.5-0.2,0.8-0.2c0.4,0,0.7,0.1,0.9,0.3C17.9,9,18,9.3,18,9.7
\t\tc0,0.2,0,0.5-0.1,0.9l-0.5,2.6H16l0.6-2.6c0.1-0.4,0.1-0.6,0.1-0.7c0-0.2,0-0.3-0.1-0.4c-0.1-0.1-0.2-0.1-0.4-0.1
\t\tc-0.2,0-0.4,0.1-0.6,0.2S15.1,10,15,10.2c-0.1,0.2-0.2,0.6-0.3,1.1l-0.4,1.9H13L14,8.6z"/>
\t<path fill="currentColor" d="M19,8.6h1.3l-1,4.7h-1.3L19,8.6z M19.4,6.8h1.3L20.4,8h-1.3L19.4,6.8z"/>
\t<path fill="currentColor" d="M20.3,11.3c0-0.9,0.2-1.6,0.7-2.1c0.5-0.5,1.1-0.8,1.9-0.8c0.7,0,1.2,0.2,1.6,0.6c0.4,0.4,0.6,0.9,0.6,1.5
\t\tc0,0.8-0.2,1.4-0.7,2s-1.1,0.8-1.9,0.8c-0.4,0-0.8-0.1-1.2-0.3s-0.6-0.4-0.8-0.7S20.3,11.7,20.3,11.3z M23.9,10.4
\t\tc0-0.3-0.1-0.5-0.3-0.7c-0.2-0.2-0.4-0.3-0.7-0.3c-0.3,0-0.5,0.1-0.7,0.3c-0.2,0.2-0.4,0.4-0.5,0.7c-0.1,0.3-0.2,0.6-0.2,0.9
\t\tc0,0.3,0.1,0.6,0.3,0.8s0.4,0.3,0.7,0.3c0.3,0,0.6-0.1,0.9-0.4C23.7,11.5,23.9,11,23.9,10.4z"/>
\t<path fill="currentColor" d="M26.2,8.6h1.2l-0.1,0.6c0.3-0.3,0.6-0.4,0.8-0.6c0.3-0.1,0.5-0.2,0.8-0.2c0.4,0,0.7,0.1,0.9,0.3C30,9,30.1,9.3,30.1,9.7
\t\tc0,0.2,0,0.5-0.1,0.9l-0.5,2.6h-1.3l0.6-2.6c0.1-0.4,0.1-0.6,0.1-0.7c0-0.2,0-0.3-0.1-0.4c-0.1-0.1-0.2-0.1-0.4-0.1
\t\tc-0.2,0-0.4,0.1-0.6,0.2s-0.4,0.4-0.5,0.6c-0.1,0.2-0.2,0.6-0.3,1.1l-0.4,1.9h-1.3L26.2,8.6z"/>
\t<path fill="currentColor" d="M31.5,13.3h-1.3l1.3-6.4h2.6c0.5,0,0.8,0.1,1.1,0.2c0.3,0.1,0.5,0.3,0.6,0.5s0.2,0.6,0.2,0.9c0,0.3-0.1,0.6-0.2,0.9
\t\tc-0.1,0.3-0.3,0.6-0.5,0.7c-0.2,0.2-0.4,0.3-0.6,0.4s-0.5,0.2-0.9,0.2c-0.2,0-0.6,0-1.2,0h-0.8L31.5,13.3z M32.3,9.8h0.4
\t\tc0.7,0,1.2,0,1.4-0.1s0.4-0.2,0.6-0.4s0.2-0.4,0.2-0.6c0-0.2,0-0.3-0.1-0.4C34.7,8.1,34.6,8,34.4,8c-0.1,0-0.4-0.1-0.8-0.1h-0.9
\t\tL32.3,9.8z"/>
\t<path fill="currentColor" d="M37.5,9.9l-1.2-0.1c0.1-0.4,0.4-0.7,0.7-1c0.4-0.2,0.8-0.4,1.4-0.4c0.6,0,1,0.1,1.3,0.4c0.3,0.2,0.4,0.5,0.4,0.9
\t\tc0,0.1,0,0.3,0,0.4c0,0.2-0.1,0.6-0.3,1.2c-0.1,0.6-0.2,0.9-0.2,1.2c0,0.2,0,0.4,0.1,0.7h-1.2c-0.1-0.2-0.1-0.3-0.1-0.5
\t\tc-0.2,0.2-0.4,0.4-0.6,0.5c-0.2,0.1-0.5,0.2-0.7,0.2c-0.4,0-0.7-0.1-1-0.4c-0.3-0.3-0.4-0.6-0.4-1c0-0.4,0.1-0.8,0.4-1.1
\t\tc0.3-0.3,0.8-0.4,1.5-0.5c0.6,0,1-0.1,1.2-0.2C39,10.1,39,10,39,9.9c0-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.3-0.1-0.5-0.1
\t\tc-0.2,0-0.4,0-0.5,0.1C37.7,9.6,37.6,9.8,37.5,9.9z M38.7,11.1c-0.1,0-0.2,0-0.3,0.1c-0.6,0.1-1,0.2-1.2,0.3
\t\tc-0.1,0.1-0.2,0.2-0.2,0.4c0,0.1,0.1,0.3,0.2,0.4c0.1,0.1,0.2,0.2,0.4,0.2c0.2,0,0.4,0,0.5-0.1c0.2-0.1,0.3-0.2,0.4-0.4
\t\tc0.1-0.1,0.2-0.4,0.2-0.7L38.7,11.1z"/>
\t<path fill="currentColor" d="M40.7,8.6H42l0.3,2.3c0.1,0.6,0.1,1,0.1,1.3c0.2-0.5,0.4-1,0.7-1.5l1.1-2.1h1.3l-2.9,5.1c-0.2,0.4-0.4,0.7-0.6,0.9
\t\tc-0.1,0.2-0.3,0.3-0.5,0.4c-0.2,0.1-0.4,0.1-0.7,0.1c-0.3,0-0.6,0-0.9-0.1l0.1-0.9c0.2,0,0.3,0.1,0.4,0.1c0.4,0,0.7-0.3,1-0.9
\t\tL40.7,8.6z"/>
</g>
<g>
\t<path fill="currentColor" d="M26.9,16.3h-1.6c-0.1,0.2-0.2,0.4-0.3,0.6h1.6v1h-0.7v0.9h1v1h-1v1.3c0.3-0.2,0.5-0.3,0.8-0.5c0,0.4,0,0.8,0.1,1.2
\t\tc-1,0.6-1.5,1-1.7,1.2l-0.6-0.9c0.2-0.2,0.3-0.5,0.3-0.8v-1.4h-1v-1h1V18h-0.3c-0.1,0.2-0.2,0.4-0.4,0.6c-0.1-0.5-0.2-1-0.3-1.4
\t\tc0.5-0.9,0.9-1.9,1.1-2.9c0.7,0.2,1.1,0.2,1.1,0.2c-0.1,0.3-0.2,0.6-0.3,0.9h1.3V16.3z M31.7,19.2l0.7,1l-1.5,0.8
\t\tc0.4,0.4,1,0.6,1.7,0.7c-0.3,0.4-0.5,0.8-0.7,1.1c-0.9-0.3-1.5-0.7-2-1.3c0,0.2,0,0.4,0,0.6c-1.1,0.4-1.9,0.7-2.4,0.9l-0.5-0.9
\t\tc0.2-0.2,0.3-0.5,0.3-0.9v-6.6H32v4.6H31.7z M30.8,15.7h-2.5v0.7h2.5V15.7z M30.8,18.1v-0.7h-2.5v0.7H30.8z M28.7,19.2h-0.3v2.3
\t\tc0.4-0.1,0.7-0.3,1.1-0.4C29.1,20.5,28.9,19.9,28.7,19.2z M31.7,19.2h-1.8c0.1,0.4,0.3,0.7,0.4,1C30.7,19.9,31.2,19.6,31.7,19.2z"
\t\t/>
\t<path fill="currentColor" d="M32.5,21.9l-0.2-1.2c0.1,0,0.3,0,0.5-0.1v-4.9h-0.4v-1h3.8v1h-0.4v4.4c0.2,0,0.3-0.1,0.5-0.1c0,0.4-0.1,0.8-0.1,1.1
\t\tc-0.1,0-0.3,0-0.4,0.1v1.6h-1.1v-1.4L32.5,21.9z M33.8,16.7h0.9v-0.9h-0.9V16.7z M33.8,18.6h0.9v-0.9h-0.9V18.6z M34.7,20.4v-0.9
\t\th-0.9v1L34.7,20.4z M37.3,14.3c0.3,0.4,0.6,0.8,0.9,1.3L37.4,16h1.2c0.3-0.6,0.6-1.1,0.9-1.7l1.1,0.5L39.8,16h0.9v1h-1.7
\t\tc0,0.6,0,1,0,1.2h2v1h-1.8c0.3,1.1,1,2,1.9,2.5c-0.2,0.4-0.5,0.7-0.7,1.2c-0.9-0.7-1.5-1.7-1.9-3c-0.2,1.2-0.8,2.3-1.8,3
\t\tc-0.3-0.4-0.6-0.7-0.9-1c1-0.6,1.6-1.5,1.8-2.7h-1.6v-1h1.7c0-0.1,0-0.6,0-1.2h-1.5v-1h0.9c-0.2-0.5-0.5-0.9-0.7-1.2L37.3,14.3z"/>
</g>
</svg>`,

    'Diners': `<svg version="1.1" id="dinnerclub-outline-large" width="26px" height="26px"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
\t viewBox="0 0 48 32" enable-background="new 0 0 48 32" xml:space="preserve">
<g id="dinnerclub-outline-large_1_" transform="translate(1104.000000, 564.000000)">
\t<path fill="none" d="M-1100-564h40c2.2,0,4,1.8,4,4v24c0,2.2-1.8,4-4,4h-40c-2.2,0-4-1.8-4-4v-24C-1104-562.2-1102.2-564-1100-564z
\t\t"/>
\t<path fill="currentColor" d="M-1060-562c1.1,0,2,0.9,2,2v24c0,1.1-0.9,2-2,2h-40c-1.1,0-2-0.9-2-2v-24c0-1.1,0.9-2,2-2H-1060z
\t\t M-1060-564h-40c-2.2,0-4,1.8-4,4v24c0,2.2,1.8,4,4,4h40c2.2,0,4-1.8,4-4v-24C-1056-562.2-1057.8-564-1060-564z"/>
\t<g transform="translate(8.000000, 4.000000)">
\t\t<path fill="currentColor" d="M-1101.6-545c2.3,0,2.7-1.6,2.7-2.3c0-0.7-0.3-1.3-0.8-1.7c-0.5-0.4-1.1-0.6-1.8-0.6h-1.9v0.2
\t\t\tc0.3,0,0.6,0,0.6,0.6v3.2c0,0.5-0.2,0.5-0.6,0.5v0.2H-1101.6L-1101.6-545z M-1102.1-549.3c0.2,0,0.3,0,0.5,0
\t\t\tc0.5,0,1.1,0.2,1.5,0.6c0.4,0.4,0.6,0.9,0.5,1.5c0.1,0.5-0.1,1-0.5,1.4c-0.4,0.4-0.9,0.6-1.4,0.6c-0.3,0-0.7-0.1-0.7-0.6
\t\t\tL-1102.1-549.3z"/>
\t\t<path fill="currentColor" d="M-1097.2-545v-0.2h-0.1c-0.2,0-0.3,0-0.3-0.2v-2.5v-0.1c0,0-0.1,0-0.1,0c-0.2,0.1-0.5,0.2-0.7,0.2v0.1
\t\t\tc0.2,0.1,0.3,0.2,0.3,0.5v1.8c0,0.2-0.1,0.2-0.3,0.2h-0.1v0.2H-1097.2L-1097.2-545z"/>
\t\t<path fill="currentColor" d="M-1097.9-548.9c0.1,0,0.2,0,0.2-0.1s0.1-0.1,0.1-0.2c0-0.2-0.1-0.3-0.3-0.3c-0.2,0-0.3,0.1-0.3,0.3
\t\t\tC-1098.3-549.1-1098.1-548.9-1097.9-548.9L-1097.9-548.9z"/>
\t\t<path fill="currentColor" d="M-1093.8-545.1h-0.1c-0.2,0-0.3,0-0.3-0.2v-1.7c0-0.5-0.2-0.9-0.8-0.9c-0.4,0-0.8,0.2-1.1,0.5v-0.4
\t\t\tc0,0,0-0.1,0-0.1c-0.3,0.1-0.6,0.2-0.9,0.3v0.1c0.3,0.1,0.4,0.2,0.4,0.4l0,0v1.7c0,0.2-0.1,0.2-0.3,0.2h-0.1v0.1h1.4v-0.2h-0.1
\t\t\tc-0.2,0-0.3,0-0.3-0.2v-1.9c0.2-0.2,0.5-0.3,0.8-0.3c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.2,0.3,0.2,0.4v1.7c0,0.2-0.1,0.2-0.3,0.2h-0.1
\t\t\tv0.1h1.3V-545.1z"/>
\t\t<path fill="currentColor" d="M-1092.6-544.9c0.5,0,1-0.3,1.2-0.7l-0.1-0.1c-0.2,0.3-0.5,0.4-0.9,0.4c-0.6,0-1-0.5-1-1.1
\t\t\tc0-0.1,0-0.3,0-0.4h1.8h0.1v-0.1c0-0.3-0.1-0.6-0.3-0.7c-0.2-0.2-0.5-0.3-0.8-0.3c-0.4,0-1.3,0.4-1.3,1.7c0,0.4,0.1,0.7,0.4,0.9
\t\t\tC-1093.3-545-1092.9-544.9-1092.6-544.9z M-1092.6-547.7c0.2,0,0.3,0.1,0.4,0.2s0.2,0.3,0.1,0.4c0,0.1,0,0.2-0.2,0.2h-1.1
\t\t\tC-1093.2-547.4-1092.9-547.7-1092.6-547.7L-1092.6-547.7z"/>
\t\t<path fill="currentColor" d="M-1091.1-545.1h-0.2v0.1h1.7v-0.2h-0.4c-0.2,0-0.3,0-0.3-0.2v-1.5c0-0.3,0.2-0.5,0.5-0.5
\t\t\tc0.2,0,0.2,0.2,0.4,0.2c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0.1-0.1,0.1-0.2c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.2-0.1-0.3-0.1
\t\t\tc-0.4,0-0.7,0.4-0.8,0.7l0,0v-0.6c0-0.1,0-0.1-0.1-0.1c-0.1,0-0.3,0.2-0.8,0.4v0.1c0.1,0,0.3,0.1,0.3,0.3v1.8
\t\t\tC-1090.8-545.1-1090.9-545.1-1091.1-545.1z"/>
\t\t<path fill="currentColor" d="M-1087.9-545.1c-0.4,0-0.8-0.4-0.8-0.8h-0.1l0.1,0.7c0.2,0.1,0.5,0.2,0.8,0.2c0.8,0,1.1-0.5,1.1-0.9
\t\t\tc0-1-1.5-0.8-1.5-1.6c0-0.1,0.1-0.2,0.2-0.3s0.2-0.1,0.3-0.1c0.4,0,0.7,0.3,0.7,0.6h0.2l-0.1-0.7c-0.2-0.1-0.5-0.2-0.7-0.2
\t\t\tc-0.2,0-0.5,0-0.7,0.2s-0.3,0.4-0.3,0.6c0,1,1.4,0.8,1.4,1.6c0,0.1,0,0.3-0.2,0.4C-1087.6-545.1-1087.8-545-1087.9-545.1
\t\t\tL-1087.9-545.1z"/>
\t\t<path fill="currentColor" d="M-1081.1-545.2l0.2-0.9h-0.2c-0.1,0.6-0.7,1.1-1.3,1.1c-1.2-0.1-2-1.1-1.9-2.3c-0.1-0.5,0.1-1,0.5-1.4
\t\t\tc0.3-0.4,0.9-0.6,1.4-0.6c0.7-0.1,1.3,0.4,1.4,1.1h0.2l-0.1-0.9c-0.5-0.2-1-0.3-1.5-0.4c-1.3,0-2.4,1-2.5,2.3
\t\t\tc0,0.7,0.2,1.3,0.7,1.8c0.5,0.5,1.1,0.7,1.8,0.7C-1082.1-544.9-1081.6-545-1081.1-545.2L-1081.1-545.2z"/>
\t\t<path fill="currentColor" d="M-1079.4-545v-0.2h-0.1c-0.2,0-0.3,0-0.3-0.2v-4.5v-0.1c0,0-0.1,0-0.1,0.1c-0.2,0.1-0.4,0.2-0.7,0.3v0.1
\t\t\tc0.2,0.1,0.3,0.1,0.3,0.5v3.6c0,0.2-0.1,0.2-0.3,0.2h-0.1v0.2H-1079.4L-1079.4-545z"/>
\t\t<path fill="currentColor" d="M-1079-547.3v1.7c0,0.2,0,0.4,0.2,0.6c0.1,0.1,0.3,0.2,0.5,0.2c0.4,0,0.9-0.2,1.2-0.5v0.5l0,0
\t\t\tc0.3-0.1,0.6-0.2,0.9-0.2v-0.1h-0.2c-0.1,0-0.2,0-0.2-0.1v-2.4c0-0.1,0-0.1,0-0.1s-0.4,0.1-1,0.1v0.1c0.2,0.1,0.5,0.1,0.5,0.3v1.8
\t\t\tc-0.2,0.2-0.5,0.3-0.8,0.4c-0.6,0-0.6-0.6-0.6-0.8v-1.7c0-0.1,0-0.2-0.1-0.2l-0.8,0.1v0.1C-1079-547.6-1079-547.5-1079-547.3z"/>
\t\t<path fill="currentColor" d="M-1075.8-549v2.8c0,0.4,0,0.8-0.1,1.2l0.1,0.1l0.2-0.2c0.3,0.1,0.6,0.2,0.9,0.2c0.9,0,1.6-0.8,1.6-1.7
\t\t\tc0-0.3-0.1-0.7-0.3-0.9s-0.6-0.4-0.9-0.4c-0.4,0-0.7,0.2-1,0.5l0,0v-2.4c0,0,0-0.1-0.1-0.1l-0.2,0.1c-0.2,0.1-0.4,0.2-0.7,0.3v0.1
\t\t\tC-1075.9-549.4-1075.8-549.4-1075.8-549z M-1075.3-547.3c0.2-0.2,0.4-0.3,0.6-0.3c0.6,0.1,1,0.7,1,1.3c0,0.6-0.3,1.3-1,1.3
\t\t\tc-0.4,0-0.7-0.3-0.7-0.7L-1075.3-547.3z"/>
\t\t<path fill="currentColor" d="M-1102.9-543.5h-0.5l0,0v0.1h0.1c0.1,0,0.2,0,0.2,0.2v1.9c0,0.2-0.1,0.2-0.2,0.2h-0.1v0.2l0,0h0.5h0.6l0,0
\t\t\tv-0.1h0c-0.1,0-0.2,0-0.2-0.2v-1.9c0-0.2,0.1-0.2,0.2-0.2h0.1v-0.1l0,0L-1102.9-543.5z"/>
\t\t<path fill="currentColor" d="M-1099.8-543.5h-0.5l0,0v0.1h0.1c0.1,0,0.3,0,0.3,0.3v1.3l-1.6-1.8c-0.1,0-0.2,0-0.3,0h-0.4l0,0v0.1h0.1
\t\t\tc0.1,0,0.2,0,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2v1.5c0,0.3-0.1,0.4-0.3,0.4h-0.1v0.2l0,0h0.5h0.4l0,0v-0.1h-0.1
\t\t\tc-0.3,0-0.3-0.1-0.3-0.4v-1.5l1.8,2h0.2l0,0c0-0.1,0-0.2,0-0.3v-1.7c0-0.4,0.2-0.4,0.3-0.4h0.1v-0.1l0,0L-1099.8-543.5z"/>
\t\t<path fill="currentColor" d="M-1096.8-543.7L-1096.8-543.7c0,0.1-0.1,0.1-0.2,0.1h-1.8c-0.1,0-0.2,0-0.2-0.1h-0.1l0,0
\t\t\tc0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3l0,0h0.1c0.1-0.3,0.1-0.3,0.3-0.3l0,0l0,0l0,0h0.6v1.9c0,0.3-0.1,0.3-0.3,0.3h-0.1v0.2l0,0
\t\t\th0.6h0.6l0,0v-0.1h-0.1c-0.2,0-0.3,0-0.3-0.3v-1.9h0.6c0.2,0,0.2,0.2,0.2,0.3l0,0l0.1,0l0,0v-0.3
\t\t\tC-1096.8-543.5-1096.8-543.5-1096.8-543.7L-1096.8-543.7L-1096.8-543.7L-1096.8-543.7z"/>
\t\t<path fill="currentColor" d="M-1094.7-541.7L-1094.7-541.7c-0.1,0.4-0.3,0.4-0.7,0.4c-0.2,0-0.4,0-0.4-0.2v-0.8h0.4
\t\t\tc0.2,0,0.2,0.1,0.3,0.3l0,0h0.1l0,0c0-0.1,0-0.3,0-0.4s0-0.3,0-0.4l0,0h-0.1l0,0c0,0.2-0.1,0.3-0.3,0.3h-0.4v-0.9h0.5
\t\t\tc0.4,0,0.4,0.2,0.4,0.4l0,0h0.1l0,0c0-0.1,0-0.2,0-0.4v-0.2l0,0h-0.9h-0.9l0,0v0.1h0.1c0.1,0,0.2,0,0.2,0.2v1.9
\t\t\tc0,0.2-0.1,0.2-0.2,0.2h-0.1v0.2l0,0h0.9h1l0,0l0,0c0-0.2,0.1-0.4,0.1-0.6l0,0h-0.1L-1094.7-541.7z"/>
\t\t<path fill="currentColor" d="M-1092.4-541.4l-0.6-0.9c0.3-0.1,0.5-0.3,0.5-0.6c0-0.5-0.4-0.6-0.9-0.6h-0.6h-0.5l0,0v0.1h0.1
\t\t\tc0.1,0,0.2,0,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-0.1v0.2l0,0h0.5h0.6l0,0v-0.1h-0.1c-0.2,0-0.3,0-0.3-0.3v-0.8h0.2
\t\t\tc0.2,0.4,0.5,0.8,0.7,1.1c0.1,0,0.2,0,0.3,0l0.4,0.1l0,0v-0.1l0,0C-1092.2-541.1-1092.3-541.2-1092.4-541.4L-1092.4-541.4z
\t\t\t M-1093-542.9c0,0.4-0.2,0.5-0.5,0.5h-0.2v-1h0.2c0.1,0,0.3,0,0.4,0.1C-1093.1-543.2-1093-543-1093-542.9L-1093-542.9z"/>
\t\t<path fill="currentColor" d="M-1089.1-543.4v-0.1l0,0h-0.4h-0.5l0,0v0.1h0.1c0.1,0,0.3,0,0.3,0.3v1.3l-1.6-1.8c-0.1,0-0.2,0-0.3,0h-0.4
\t\t\tl0,0v0.1h0.1c0.1,0,0.2,0,0.2,0.1s0.1,0.1,0.1,0.2v1.5c0,0.3-0.1,0.4-0.3,0.4h-0.1v0.2l0,0h0.5h0.4l0,0v-0.1h-0.1
\t\t\tc-0.3,0-0.3-0.1-0.3-0.4v-1.5l1.8,2h0.2l0,0c0-0.1,0-0.2,0-0.3v-1.7C-1089.4-543.4-1089.3-543.4-1089.1-543.4L-1089.1-543.4
\t\t\tL-1089.1-543.4z"/>
\t\t<path fill="currentColor" d="M-1086.9-541.3c0-0.1-0.1-0.2-0.1-0.4l-0.7-1.9v-0.1l0,0l0,0c-0.1,0.1-0.2,0.1-0.3,0.2
\t\t\tc0,0.2-0.1,0.3-0.1,0.4l-0.6,1.6c0,0.1-0.2,0.2-0.3,0.2l0,0v0.2l0,0h0.4h0.4l0,0v-0.1h-0.1c-0.1,0-0.2,0-0.2-0.1
\t\t\tc0-0.1,0-0.2,0.1-0.3l0.1-0.4h0.8l0.1,0.4c0,0.1,0.1,0.2,0.1,0.2c0,0.1-0.1,0.1-0.2,0.1h-0.1v0.1l0,0h0.5h0.5l0,0v-0.1l0,0
\t\t\tc-0.1,0-0.2,0-0.2,0S-1086.9-541.2-1086.9-541.3L-1086.9-541.3z M-1087.7-542.2h-0.6l0.3-1L-1087.7-542.2z"/>
\t\t<path fill="currentColor" d="M-1084.5-543.7L-1084.5-543.7c0,0.1-0.1,0.1-0.2,0.1h-1.8c-0.1,0-0.2,0-0.2-0.1h-0.1l0,0
\t\t\tc0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3h0.1c0-0.3,0-0.3,0.3-0.3l0,0l0,0l0,0h0.6v1.9c0,0.3-0.1,0.3-0.3,0.3h-0.1v0.2l0,0h0.6h0.6
\t\t\tl0,0v-0.1h-0.1c-0.2,0-0.3,0-0.3-0.3v-1.9h0.6c0.2,0,0.2,0.2,0.2,0.3l0,0l0.1,0l0,0c0-0.1,0-0.2,0-0.3
\t\t\tC-1084.4-543.5-1084.4-543.5-1084.5-543.7L-1084.5-543.7L-1084.5-543.7L-1084.5-543.7z"/>
\t\t<path fill="currentColor" d="M-1083.8-543.5h-0.5l0,0v0.1h0.1c0.1,0,0.2,0,0.2,0.2v1.9c0,0.2-0.1,0.2-0.2,0.2h-0.1v0.2l0,0h0.5h0.6l0,0
\t\t\tv-0.1h-0.1c-0.1,0-0.2,0-0.2-0.2v-1.9c0-0.2,0.1-0.2,0.2-0.2h0.1v-0.1l0,0L-1083.8-543.5z"/>
\t\t<path fill="currentColor" d="M-1081.8-543.6c-0.4,0-0.7,0.1-0.9,0.4c-0.2,0.2-0.4,0.6-0.4,0.9l0,0c0,0.4,0.1,0.7,0.4,0.9
\t\t\tc0.3,0.2,0.6,0.4,1,0.4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1c0-0.4-0.2-0.7-0.4-0.9
\t\t\tC-1081.1-543.5-1081.5-543.6-1081.8-543.6z M-1081.8-543.4c0.6,0,0.8,0.6,0.8,1.1c0,0.5-0.1,1.1-0.8,1.1s-0.8-0.6-0.8-1.2
\t\t\tC-1082.6-542.9-1082.4-543.4-1081.8-543.4L-1081.8-543.4z"/>
\t\t<path fill="currentColor" d="M-1077.5-543.4v-0.1l0,0h-0.4h-0.5l0,0v0.1h0.1c0.1,0,0.3,0,0.3,0.3v1.3l-1.6-1.8c-0.1,0-0.2,0-0.3,0h-0.4
\t\t\tl0,0v0.1h0.1c0.1,0,0.2,0,0.2,0.1s0.1,0.1,0.1,0.2v1.5c0,0.3-0.1,0.4-0.3,0.4h-0.1v0.2l0,0h0.5h0.5l0,0v-0.1h-0.1
\t\t\tc-0.3,0-0.3-0.1-0.3-0.4v-1.5l1.8,2h0.2l0,0c0-0.1,0-0.2,0-0.3v-1.7C-1077.8-543.4-1077.7-543.4-1077.5-543.4L-1077.5-543.4
\t\t\tL-1077.5-543.4z"/>
\t\t<path fill="currentColor" d="M-1075.3-541.3c0-0.1-0.1-0.2-0.1-0.4l-0.6-1.9v-0.1l0,0l0,0c-0.1,0.1-0.2,0.1-0.3,0.2
\t\t\tc0,0.2-0.1,0.3-0.1,0.4l-0.6,1.6c0,0.1-0.2,0.2-0.3,0.2l0,0v0.2l0,0h0.4h0.4l0,0v-0.1l0,0c-0.1,0-0.2,0-0.2-0.1
\t\t\tc0-0.1,0-0.2,0.1-0.3l0.1-0.4h0.7l0.1,0.4c0,0.1,0.1,0.2,0.1,0.2c0,0.1-0.1,0.1-0.2,0.1h-0.1v0.1l0,0h0.5h0.5l0,0v-0.1l0,0
\t\t\tc-0.1,0-0.1,0-0.2,0C-1075.3-541.2-1075.3-541.3-1075.3-541.3z M-1076.1-542.2h-0.6l0.3-1L-1076.1-542.2z"/>
\t\t<path fill="currentColor" d="M-1073-541.7L-1073-541.7c0,0.1-0.1,0.2-0.1,0.2c-0.1,0.1-0.2,0.2-0.3,0.2h-0.5c-0.1,0-0.2,0-0.2-0.2v-1.8
\t\t\tc0-0.2,0.1-0.2,0.2-0.2h0.1v-0.1l0,0h-0.5h-0.6l0,0v0.1h0.1c0.1,0,0.2,0,0.2,0.2v1.8c0,0.2-0.1,0.2-0.2,0.2h-0.1v0.2l0,0h0.9h0.9
\t\t\tl0,0l0,0c0-0.2,0.1-0.4,0.1-0.6l0,0L-1073-541.7L-1073-541.7z"/>
\t\t<path fill="currentColor" d="M-1073-543.6c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4c0-0.1,0-0.2-0.1-0.3
\t\t\tC-1072.8-543.6-1072.9-543.6-1073-543.6L-1073-543.6z M-1073-543c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3s0.3,0.1,0.3,0.3
\t\t\tc0,0.1,0,0.2-0.1,0.2C-1072.8-543-1072.9-543-1073-543L-1073-543z"/>
\t\t<path fill="currentColor" d="M-1072.9-543.3c0.1,0,0.1-0.1,0.1-0.1c0-0.1-0.1-0.1-0.1-0.1h-0.2l0,0c0,0,0,0,0,0v0.3l0,0l0,0h0.2l0,0
\t\t\tc-0.1,0-0.1,0-0.1,0v-0.1l0,0c0.1,0.1,0.1,0.2,0.1,0.2h0.1L-1072.9-543.3L-1072.9-543.3z M-1073-543.3v-0.2l0,0c0,0,0,0,0.1,0
\t\t\tC-1073-543.4-1073-543.4-1073-543.3C-1073-543.3-1073-543.3-1073-543.3L-1073-543.3z"/>
\t\t<path fill="currentColor" d="M-1093.2-556.7c0,1.5,0.9,2.9,2.4,3.4v-6.8C-1092.3-559.6-1093.2-558.2-1093.2-556.7z"/>
\t\t<path fill="currentColor" d="M-1088.3-560.1v6.8c1.4-0.5,2.3-1.9,2.3-3.4C-1085.9-558.2-1086.9-559.6-1088.3-560.1L-1088.3-560.1z"/>
\t\t<path fill="currentColor" d="M-1086.6-563h-3c-1.7,0-3.3,0.6-4.5,1.8c-1.2,1.2-1.9,2.8-1.8,4.5c0,3.5,2.9,6.3,6.3,6.2h3
\t\t\tc3.5,0,6.4-2.7,6.6-6.2c0-1.7-0.7-3.4-2-4.5C-1083.3-562.4-1084.9-563-1086.6-563L-1086.6-563z M-1089.6-551
\t\t\tc-3.2,0-5.8-2.6-5.8-5.8s2.6-5.8,5.8-5.8s5.8,2.6,5.8,5.8S-1086.4-551-1089.6-551L-1089.6-551z"/>
\t</g>
</g>
</svg>`,

    'JCB': `<svg version="1.1" id="jcb-outline-large" width="26px" height="26px"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
\t viewBox="0 0 48 32" enable-background="new 0 0 48 32" xml:space="preserve">
\t 
<g id="jcb-outline-large_1_" transform="translate(880.000000, 564.000000)">
\t<path fill="none" d="M-876-564h40c2.2,0,4,1.8,4,4v24c0,2.2-1.8,4-4,4h-40c-2.2,0-4-1.8-4-4v-24C-880-562.2-878.2-564-876-564z"/>
\t<path fill="currentColor" d="M-836-562c1.1,0,2,0.9,2,2v24c0,1.1-0.9,2-2,2h-40c-1.1,0-2-0.9-2-2v-24c0-1.1,0.9-2,2-2H-836z M-836-564
\t\th-40c-2.2,0-4,1.8-4,4v24c0,2.2,1.8,4,4,4h40c2.2,0,4-1.8,4-4v-24C-832-562.2-833.8-564-836-564z"/>
\t<g transform="translate(8.000000, 4.000000)">
\t\t<path fill="currentColor" d="M-855.9-549.4h2.3h0.3c0.5-0.1,0.8-0.5,0.8-1c0-0.5-0.3-0.9-0.8-1c-0.1,0-0.2,0-0.3,0h-2.3V-549.4z"/>
\t\t<path fill="currentColor" d="M-853.9-564c-2.2,0-4,1.8-4,4v4.2h5.6c0.1,0,0.3,0,0.4,0c1.3,0.1,2.2,0.7,2.2,1.9c0,1-0.8,1.8-1.8,1.8l0,0
\t\t\tc1.3,0.1,2.3,0.8,2.3,1.9c0,1.1-1.1,2-2.5,2h-6.2v8.2h5.9c2.2,0,4-1.8,4-4v-20H-853.9z"/>
\t\t<path fill="currentColor" d="M-852.8-553.7c0-0.5-0.3-0.9-0.8-1h-0.2h-2.1v1.9h2.1c0.1,0,0.1,0,0.2,0
\t\t\tC-853.1-552.8-852.8-553.2-852.8-553.7L-852.8-553.7z"/>
\t\t<path fill="currentColor" d="M-876-564c-2.2,0-4,1.8-4,4v9.9c1.1,0.6,2.2,0.9,3.5,0.9c0.6,0.1,1.1-0.1,1.5-0.5c0.4-0.4,0.6-0.9,0.6-1.5
\t\t\tv-4.6h3.4v4.6c0,1.8-1.1,3.3-4.9,3.3c-1.4,0-2.7-0.2-4.1-0.5v8.5h5.9c2.2,0,4-1.8,4-4v-20H-876z"/>
\t\t<path fill="currentColor" d="M-864.9-564c-2.2,0-4,1.8-4,4v5.2c1-0.9,2.8-1.4,5.6-1.3c1.1,0.1,2.1,0.2,3.1,0.5v1.7
\t\t\tc-0.9-0.5-1.9-0.8-3-0.9c-2.2-0.2-3.5,0.9-3.5,2.8s1.3,2.9,3.5,2.8c1-0.1,2.1-0.4,3-0.9v1.7c-1,0.3-2.1,0.4-3.1,0.5
\t\t\tc-2.8,0.1-4.6-0.4-5.6-1.3v9.2h5.9c2.2,0,4-1.8,4-4v-20H-864.9z"/>
\t</g>
</g>
</svg>`,

    'Maestro': `<svg version="1.1" id="mastercard-outline-large" width="26px" height="26px"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
\t viewBox="0 0 48 32" enable-background="new 0 0 48 32" xml:space="preserve">
<g id="mastercard-outline-large_1_" transform="translate(208.000000, 564.000000)">
\t<path fill="none" d="M-204-564h40c2.2,0,4,1.8,4,4v24c0,2.2-1.8,4-4,4h-40c-2.2,0-4-1.8-4-4v-24C-208-562.2-206.2-564-204-564z"/>
\t<path fill="currentColor" d="M-164-562c1.1,0,2,0.9,2,2v24c0,1.1-0.9,2-2,2h-40c-1.1,0-2-0.9-2-2v-24c0-1.1,0.9-2,2-2H-164z M-164-564
\t\th-40c-2.2,0-4,1.8-4,4v24c0,2.2,1.8,4,4,4h40c2.2,0,4-1.8,4-4v-24C-160-562.2-161.8-564-164-564z"/>
\t<g transform="translate(4.000000, 3.000000)">
\t\t<g opacity="0">
\t\t\t<rect x="-207.4" y="-563.8" fill="currentColor" width="38.7" height="25.6"/>
\t\t</g>
\t\t<path fill="currentColor" d="M-189.8-541.5c-4.5,2.3-9.9,1.1-13.1-2.8s-3.1-9.5,0-13.3s8.6-5.1,13.1-2.8c-2.7,2.4-4.3,5.8-4.3,9.5
\t\t\tC-194.1-547.4-192.5-543.9-189.8-541.5z"/>
\t\t<path fill="currentColor" d="M-171.9-544.4v-0.3h0.2v-0.1h-0.4v0.1h0.1L-171.9-544.4L-171.9-544.4z M-171.2-544.4v-0.4h-0.1l-0.1,0.3
\t\t\tl-0.1-0.3h-0.1v0.4h0.1v-0.3l0.1,0.3h0.1l0.1-0.3L-171.2-544.4L-171.2-544.4z"/>
\t\t<path fill="currentColor" d="M-170.8-551c0,3.7-1.9,7.1-5,9c-3.1,1.9-7,2.1-10.3,0.4c5-4.4,5.7-12,1.6-17.3c-0.5-0.6-1-1.2-1.6-1.7
\t\t\tc3.3-1.7,7.2-1.5,10.4,0.4C-172.7-558.1-170.8-554.7-170.8-551z"/>
\t\t<path fill="currentColor" d="M-188-542.7c-2.6-2-4.1-5.1-4.1-8.3s1.5-6.3,4.1-8.3c2.6,2,4.1,5.1,4.1,8.3S-185.4-544.7-188-542.7
\t\t\tL-188-542.7z"/>
\t</g>
</g>
</svg>`,
};

function getPaymentSystemIcon(maskedPan) {
    const schemeName = detectScheme(maskedPan);

    // Возвращаем иконку по имени или иконку "generic", если имя не найдено
    return SVG_ICONS[schemeName] || SVG_ICONS['generic'];
}


function generateCreditCardHTML(card) {
    const border = card.is_default ? "border-dark" : "";
    const masked_pan = card.masked_pan ? `${card.masked_pan.slice(0, 2)}<span class="d-none d-md-inline-block">${card.masked_pan.slice(2, 4)}</span>**<span class="d-none d-md-inline-block">${card.masked_pan.slice(-4, -2)}</span>${card.masked_pan.slice(-2)}` : ""
    let disabled = "";

    const iconSvg = getPaymentSystemIcon(card.masked_pan)

    const iconHTML = `<div class="mr-2">${iconSvg}</div>`

    const disabledSwitch = card.is_default ? "disabled" : "";

    const setAsDefaultTitle = i18next.t('common:dom.setCardAsDefaultTitle', 'Set as default')
    const deleteCard = i18next.t('common:dom.deleteCard', 'Delete')
    const deleteCardTooltipTitle = i18next.t('common:dom.deleteCardTooltipTitle', 'Delete')
    const defaultCardTitle = i18next.t('common:dom.defaultCardTitle', 'Default')
    const defaultCardTooltip = i18next.t('common:dom.defaultCardTooltip', 'Default')

    let buttonsHTML = ""
    let defaultBadgeHTML = ""

    if (card.is_default) {
        buttonsHTML = `<button class="card-button card-tooltip" data-card-id="${card.id}" data-masked-pan="${card.masked_pan}" data-bs-target="#deleteCardModal" data-bs-toggle="modal" data-bs-dismiss="modal" data-bs-placement="top" title="${deleteCardTooltipTitle}"><svg xmlns="http://www.w3.org/2000/svg" class="icon-svg" version="1.1" width="25" height="25" x="0" y="0" viewBox="0 0 24 24" xml:space="preserve"><g><g fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"><path d="M5.293 5.293a1 1 0 0 1 1.414 0l12 12a1 1 0 0 1-1.414 1.414l-12-12a1 1 0 0 1 0-1.414z" fill="currentColor" opacity="1" data-original="currentColor"></path><path d="M18.707 5.293a1 1 0 0 0-1.414 0l-12 12a1 1 0 1 0 1.414 1.414l12-12a1 1 0 0 0 0-1.414z" fill="currentColor" opacity="1" data-original="currentColor"></path></g></g></svg></button>`
        defaultBadgeHTML = `<span class="badge text-uppercase bg-light text-dark ml-2 card-tooltip" data-bs-toggle="tooltip" data-bs-placement="top" title="${defaultCardTooltip}">${defaultCardTitle}</span>`
    } else {
        buttonsHTML = `<div class="dropdown-center">
  <button class="card-button" type="button" data-bs-toggle="dropdown" aria-expanded="false">
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="15" height="15" x="0" y="0" viewBox="0 0 426.667 426.667" class="icon-svg" xml:space="preserve"><g><circle cx="42.667" cy="213.333" r="42.667" fill="currentColor" opacity="1" data-original="currentColor"></circle><circle cx="213.333" cy="213.333" r="42.667" fill="currentColor" opacity="1" data-original="currentColor"></circle><circle cx="384" cy="213.333" r="42.667" fill="currentColor" opacity="1" data-original="currentColor"></circle></g></svg>
  </button>
  <ul class="dropdown-menu">
    <li><button class="dropdown-item set-card-default" data-card-id="${card.id}">${setAsDefaultTitle}</button></li>
    <li><button class="dropdown-item ${disabled}" data-card-id="${card.id}" data-masked-pan="${card.masked_pan}" data-bs-target="#deleteCardModal"
                                       data-bs-toggle="modal" data-bs-dismiss="modal">${deleteCard}</button></li>
  </ul>
</div>`
    }

    return `<div class="col-12 mb-2" data-card-id="${card.id}" 
            data-masked-pan="${card.masked_pan}" 
            data-is-default="${card.is_default}" 
            data-is-active="${card.is_active}">
          <div class="card p-3 ${border} card-item ${disabled}">
   <div class="d-flex justify-content-between">
       <div class="d-flex align-items-center card-left">${iconHTML}<div><strong>${masked_pan}</strong></div><div class='card-badge-container'>${defaultBadgeHTML}</div></div>
       <div class="d-flex align-items-center card-right"><label class="switch card-state-switch ${disabledSwitch}" style="transform: scale(0.7);" data-card-id="${card.id}">
        <input id="card-${card.id}" class="card-state" type="checkbox" ${card.is_active ? "checked" : ""} data-card-id="${card.id}" ${disabled}>
<span class="slider round ${disabled}"></span></label>${buttonsHTML}
</div></div></div></div>`
}

export function generateCreditCardsHTML(cardsData) {
    let allCardsHTML = ""

    //console.log("cardsData", cardsData)
    const addMoreCard = i18next.t('common:dom.addMoreCard', 'Add more')


    cardsData.data.forEach(c => {
        const html = generateCreditCardHTML(c)
        allCardsHTML += html
    });

    let resHTML = `<div class="row">${allCardsHTML}</div>`

    if (cardsData.data.length < 10) {
        resHTML += `<div class="d-flex align-items-center justify-content-center mt-3">
<button id="add-more-card" class="add-more-card">+ ${addMoreCard}</button></div>`
    }

    return resHTML

}
